module.exports = __webpack_public_path__ + "img/du_03.966371e2.png";